<div class="box">
  <h4 class="mat-subtitle-1 header">
    {{ header || "Send to a conversation" }}
  </h4>

  <hr />

  <!-- Attachment preview -->
  @if (attached && attached.length) {
    <div matRipple class="attach-box">
      <div class="attach-preview">
        <div class="preview">
          @if (attachmentType === "MEDIA") {
            <img
              class="fh"
              [src]="
                '/api/v2/media/' + attached[0].id + '?size=Small'
                  | clink
                  | secure
              "
            />
          }
          @if (attachmentType === "DOCUMENT") {
            <div class="doc fw fh">
              <i class="material-icons align-self-center">insert_drive_file</i>
            </div>
          }
        </div>
        <div class="text">
          <div class="name celo-elipsis">
            {{ attached[0].fileName ? attached[0].fileName : "No name" }}
          </div>
          @if (attached[0].patientData && attached[0].patientData.uid) {
            <div class="patient">
              Patient :{{ attached[0].patientData.uid }}
            </div>
          }
        </div>
      </div>
      @if (attached.length === 1) {
        <div class="subtext">
          1 <span class="lowercase">{{ attachmentType }}</span> selected
        </div>
      }
      @if (attached.length > 1) {
        <div class="subtext">
          + {{ attached.length - 1 }}
          <span class="lowercase">{{ attachmentType }}</span>
          @if (attached.length > 2) {
            <span>s</span>
          }
          selected
        </div>
      }
    </div>
  }

  <!-- Searchbar -->
  <div class="searchbar-container">
    <app-basic-textfield
      class="searchbar"
      [placeholder]="'Search by Name, Groups, Cases & Patient ID'"
      icon="search"
      (enter)="handleSearchEnter()"
      [formControl]="searchQuery"
    ></app-basic-textfield>
  </div>

  <!-- Create new conversation button -->
  <div class="new-conversation" (click)="openCreateConvo()">
    <app-create-new-conversation-button
      [buttonText]="createNewConversationButtonText || 'Send to a new chat'"
    ></app-create-new-conversation-button>
  </div>

  <!-- Filter description -->
  <div class="bar font-14">
    @if (patientUid) {
      <span>Showing conversations for {{ patientUid }}</span>
    }
    @if (!patientUid) {
      <span>
        @if (patientUids?.length > 1) {
          <div>Showing general conversations</div>
        }
        @if (!patientUids || patientUids.length === 0) {
          <div>Showing all conversations</div>
        }
      </span>
    }
  </div>

  <!-- Conversations list -->
  <div class="content">
    @if (isSearching && userAccount) {
      @if (isSearchLoading && !searchResults.length) {
        <div class="spinner">
          <app-empty-state [isLoading]="true" message="Searching...">
          </app-empty-state>
        </div>
      }
      @if (!(isSearchLoading && !searchResults.length)) {
        <app-conversation-results
          [conversations]="searchResults"
          [userAccount]="userAccount"
          [searchKeyword]="searchResultsQuery"
          [isSelectionList]="true"
          [selectedConversationId]="convoId"
          (conversation)="onConversationSelected($event)"
        ></app-conversation-results>
      }
    } @else {
      @if (isLoading && !conversations.length) {
        <div class="spinner">
          <app-empty-state [isLoading]="true" message="Conversations">
          </app-empty-state>
        </div>
      }
      <mat-list>
        @for (convo of conversations; track convo) {
          <app-conversation-card
            class="celo-cursor-pointer"
            [userAccount]="userAccount"
            (click)="onConversationSelected(convo)"
            [selected]="convoId === convo.id"
            [inConversationList]="false"
            [activeOnly]="true"
            [hideBorder]="true"
            [convo]="convo"
          >
          </app-conversation-card>
          <hr class="conversation-card-divider" />
        }
        @if (isLoading && conversations && conversations.length) {
          <div class="spinner-box">
            <div class="spinner">
              <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
            </div>
          </div>
        }
        @if (!isLoading && hasNext) {
          <button class="fw" mat-button (click)="onLoadMore()">
            Load more
          </button>
        }
      </mat-list>
    }
  </div>

  <!-- Dialog actions -->
  <mat-dialog-actions align="end">
    <button mat-button class="celo-secondary-button uppercase" mat-dialog-close>
      Cancel
    </button>
    <button
      mat-button
      class="celo-primary-button uppercase"
      (click)="conversationId.emit(convoId); select(convoId)"
      [disabled]="!convoId"
    >
      {{ sendButtonText || "Send" }}
    </button>
  </mat-dialog-actions>
</div>
